'use client';
import useOpenCloseCashier from '../CashierWrap/useCashier/useOpenCloseCashier';
import { CashierCurrencyType } from '@/graphql/schema';

type Props = {
  type: CashierCurrencyType;
  name: CashierCurrency;
};

const Balance: FC<Props> = ({ type, name, children }) => {
  const { handleOpen } = useOpenCloseCashier({ type, name });
  return (
    <div className="cursor-pointer" onClick={handleOpen}>
      {children}
    </div>
  );
};

export default Balance;
